import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SetupState {
  companyId: number | undefined;
  storeId: number | undefined | null;
  environment: 'staging' | 'production';
  routesPrefix: string;
  pathPrefix: '/:storeId/';
  guestSessionId?: string;
  loginFrom?: 'bnplcheckout' | 'checkout' | 'profile' | 'storefront' | 'other';
}

const getInitialState = (): SetupState => ({
  companyId: undefined,
  environment: 'staging',
  storeId: undefined,
  routesPrefix: '',
  pathPrefix: '/:storeId/',
  guestSessionId: '',
  loginFrom: 'storefront',
});

const initialState = getInitialState();

const setupSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    addCompanyId: (state, action: PayloadAction<number>) => {
      state.companyId = action.payload;
    },
    addGuestSessionId: (state, action: PayloadAction<string>) => {
      state.guestSessionId = action.payload;
    },
    addStoreId: (state, action: PayloadAction<number | null>) => {
      if (action.payload) {
        state.routesPrefix = `/${action.payload.toString()}/`;
      }
      state.storeId = action.payload;
    },
    setLoginFrom: (state, action: PayloadAction<SetupState['loginFrom']>) => {
      state.loginFrom = action.payload;
    },
  },
  // extraReducers: (builder) => {
  //   // builder.addCase()
  // },
});

export const { addGuestSessionId, addCompanyId, addStoreId, setLoginFrom } =
  setupSlice.actions;
export default setupSlice.reducer;
